export const downloadFileMixin = {
  methods: {
    forceFileDownload (response, filename, extension) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${Date.now().toString()}.${extension}`)
      document.body.appendChild(link)
      link.click()
    },
    getExcelPath () {
      return ''
    },
    getFilenamePrefix () {
      return ''
    },
    downloadExcel () {
      this.axios
        .get(this.getExcelPath(), {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/xlsx'
          }
        })
        .then((response) => {
          this.forceFileDownload(response, this.getFilenamePrefix(), 'xlsx')
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}
